
namespace Gamification.Gamification {
    export class TipologieCaricamentiColumns {
        static columnsKey = 'Gamification.TipologieCaricamenti';
    }
}